import { Box, IconButton, Stack, styled, Typography } from '@mui/material';

export const SectionRoot = styled(Stack)({
  gap: 16,
  padding: '24px 40px',
  background: '#FFFFFF',
  '& + &': {
    borderTop: '1px solid #E7E8E9',
  },
});

export const Header = styled(Stack)({
  position: 'sticky',
  top: 64,
  zIndex: 5,
  background: '#FFFFFF',
  paddingTop: 8,
  paddingBottom: 8,
  flexDirection: 'row',
  alignItems: 'center',
  gap: 16,
});

export const HeaderInner = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: 16,
  width: '100%',
  maxWidth: 840,
});

export const ChevronButton = styled('button')({
  background: '#F0F1F2',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  width: 24,
  height: 24,
  borderRadius: 19,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#1A1A1A',
  fontFamily: 'inherit',
  flexShrink: 0,
  '&:hover': { background: '#E7E8E9' },
});

export const HeaderTitle = styled(Typography)({
  fontSize: 24,
  fontWeight: 700,
  lineHeight: '32px',
  color: '#010203',
  minWidth: 0,
  overflowWrap: 'anywhere',
});

export const GoalTitleRow = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  minWidth: 0,
  '& .goal-type-icon': {
    fontSize: 18,
    color: '#6E7071',
    flexShrink: 0,
  },
});

// Goal-weight chip in the goal header, mirrors OLD `TitleWeight` next to the
// goal title (`components/GoalsAndSubgoalsForm/GoalsAndSubgoalsForm.styled.ts`).
export const HeaderWeight = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  padding: '2px 8px',
  borderRadius: 4,
  background: '#F0F1F2',
  color: '#1A1A1A',
  fontSize: 14,
  fontWeight: 700,
  lineHeight: '22px',
  letterSpacing: 0,
  whiteSpace: 'nowrap',
});

export const RemoveGoalButton = styled(IconButton)({
  color: '#6E7071',
  flexShrink: 0,
  marginLeft: 'auto',
});

export const SettingsLink = styled('button')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: '#2085FF',
  fontSize: 14,
  fontWeight: 700,
  lineHeight: '22px',
  padding: '6px 8px',
  fontFamily: 'inherit',
  borderRadius: 4,
  '&:hover': { color: '#176ACE', background: 'rgba(32,133,255,0.06)' },
});

export const ContentArea = styled(Stack)({
  gap: 16,
  paddingLeft: 40,
});

export const FieldsGrid = styled(Box)({
  display: 'flex',
  gap: 16,
  alignItems: 'flex-start',
  width: '100%',
  maxWidth: 800,
  '& > .name': { flex: 1, minWidth: 0 },
  '& > .weight': { flex: '0 0 160px' },
  '& > .scale': { flex: '0 0 206px' },
  '& > .type': { flex: '0 0 206px' },
});

export const FieldGroup = styled(Stack)({
  gap: 4,
  width: '100%',
});

export const DescriptionFieldGroup = styled(FieldGroup)({
  maxWidth: 800,
});

export const descriptionFieldSx = {
  '& .MuiInputBase-root.MuiInputBase-multiline': {
    minHeight: 82,
    alignItems: 'flex-start',
    padding: '8px 10px',
  },
} as const;

export const weightHelperTextSx = {
  whiteSpace: 'nowrap',
  position: 'absolute',
  top: '100%',
  left: 0,
  margin: '3px 0 0',
} as const;

export const FieldLabel = styled('label')({
  display: 'inline-flex',
  alignItems: 'flex-start',
  gap: 2,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '22px',
  color: '#768691',
  '& .required': {
    color: '#FF0D0D',
    fontSize: 15,
    lineHeight: '18px',
  },
});

export const SubgoalsBranch = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  paddingLeft: 12,
  width: '100%',
  maxWidth: 800,
});

export const SubgoalsBranchInner = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
  borderLeft: '1px solid #E7E8E9',
  paddingLeft: 24,
  gap: 8,
  '&:hover .subgoal-drag-handle, &:focus-within .subgoal-drag-handle': {
    opacity: 1,
  },
});

export const SubgoalsHeader = styled(Typography)({
  fontSize: 18,
  fontWeight: 700,
  lineHeight: '26px',
  color: '#010203',
});

export const SubgoalsList = styled(Stack)({
  gap: 24,
});

export const AddSubgoalRow = styled(Box)({
  display: 'inline-flex',
});

export const InlineButtons = styled(Stack)({
  flexDirection: 'row',
  gap: 8,
});
